module.exports = __webpack_public_path__ + "img/lottot.42798d1a.png";